import {
  DeleteOutlined,
  EditOutlined,
  LockOutlined,
  PlusOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { Button, Col, Input, Row, Skeleton, Space, Table } from "antd";
import {
  IUpdateCompanySettings,
  useClient,
} from "../../../Context/ClientContext";
import {
  getVoucherNameBySettingsSections,
  SettingsSections,
  vouchersSettings,
} from "../../../Services/SettingService";
import { ColumnsType } from "antd/es/table";
import { useTheme } from "../../../Context/ThemeContext";
import { useContext, useEffect, useState } from "react";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import SettingVoucherTemplate from "../VoucherTemplate/SettingVoucherTemplate";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
interface ITableDataType {
  sno: number;
  voucherTitle: string;
  voucherType: number;
  system: boolean;
  id?: number;
}
const SettingSecCustomization = () => {
  const { companySettings, updateCompanySettings } = useClient();
  const { themeData } = useTheme();
  const { openNotification } = useContext(notificationContext);
  const [voucherSettings, setVoucherSettings] = useState<ITableDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [selDeleteVoucherData, setSelDeleteVoucherData] = useState<{
    id: number;
    templateName: string;
    templateType: SettingsSections;
  }>();
  const [deleteTempleteComformation, setDeleteTempleteComformation] =
    useState<boolean>(false);
  const [openModel, setOpenModel] = useState<{
    type: string;
    param?: {
      open: boolean;
      templateId?: number;
      templateName?: string;
      templateType?: SettingsSections;
    };
  }>({
    type: "",
  });

  const columns: ColumnsType<ITableDataType> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      width: "5%",
      render: (_: any, record: ITableDataType) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Voucher Title",
      dataIndex: "voucherTitle",
      width: "40%",
      render: (_: any, record: ITableDataType) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.voucherTitle}
        </Skeleton>
      ),
    },
    {
      title: "Voucher Type",
      dataIndex: "voucherType",
      width: "30%",
      render: (_: any, record: ITableDataType) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {getVoucherNameBySettingsSections(record?.voucherType)}
        </Skeleton>
      ),
    },
    {
      title: "System",
      dataIndex: "system",
      width: "10%",
      align: "center",
      render: (_: any, record: ITableDataType) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.system ? (
            <LockOutlined />
          ) : (
            <UnlockOutlined style={{ color: "green" }} />
          )}
        </Skeleton>
      ),
    },
    {
      title: "Action",
      dataIndex: "",
      align: "center",
      width: "10%",
      render: (_: any, record: ITableDataType) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <Space>
            <EditOutlined
              onClick={() => {
                setOpenModel({
                  type: "showVoucherTemplate",
                  param: {
                    open: true,
                    templateId: record.id,
                    templateName: record.voucherTitle,
                    templateType: record.voucherType,
                  },
                });
              }}
            ></EditOutlined>
            {record?.system ? (
              <DeleteOutlined style={{ color: "#D3D3D3" }}></DeleteOutlined>
            ) : (
              <DeleteOutlined
                style={{ color: "#F2003C" }}
                onClick={() => {
                  setSelDeleteVoucherData({
                    id: record?.id!,
                    templateName: record?.voucherTitle,
                    templateType: record.voucherType,
                  });
                  setDeleteTempleteComformation(true);
                }}
              ></DeleteOutlined>
            )}
          </Space>
        </Skeleton>
      ),
    },
  ];

  useEffect(() => {
    setVoucherSettings(
      companySettings!.setting.vouchersSettings.map<ITableDataType>(
        (voucher: vouchersSettings, index: number) => {
          return {
            sno: index + 1,
            id: voucher.id,
            system: voucher.system!,
            voucherTitle: voucher.title,
            voucherType: voucher.settingType,
          };
        }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  return (
    <>
      <div>
        <Row justify="space-between">
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => {
                setOpenModel({
                  type: "showVoucherTemplate",
                  param: { open: true },
                });
              }}
            >
              Voucher Template
            </Button>
          </Col>
          <Col>
            {/* <Space>
              <Input
                style={{
                  width: "200px",
                  marginTop: "-5px",
                  border: "1px solid #f1f3ff",
                }}
                allowClear={true}
                placeholder="Search voucher title"
                onChange={(e: any) => {}}
              />
            </Space> */}
          </Col>
        </Row>
        <Row>
          {/* --------- Table --------- */}
          <Table
            className={`Tabel-style table-${
              themeData?.componentSize ?? "middle"
            }`}
            pagination={false}
            columns={columns}
            style={{ width: "100%" }}
            dataSource={
              loading
                ? (Array.from({ length: 20 }, (_, index) => ({
                    sno: index,
                  })) as ITableDataType[])
                : voucherSettings
            }
          />
        </Row>
      </div>
      {openModel.type === "showVoucherTemplate" && (
        <SettingVoucherTemplate
          openDrawer={openModel.param?.open!}
          onCancel={() => setOpenModel({ type: "", param: { open: false } })}
          templateName={openModel.param?.templateName}
          templateType={openModel.param?.templateType}
          templateId={openModel.param?.templateId}
          setTrigger={setTrigger}
        />
      )}
      {deleteTempleteComformation && (
        <ConfirmationModal
          open={true}
          onNo={() => setDeleteTempleteComformation(false)}
          onYes={async () => {
            const allCustomization = companySettings?.setting?.vouchersSettings;
            const findCurrentData = allCustomization?.find(
              (x) => x.id === selDeleteVoucherData?.id
            );
            const currentDataIndex = allCustomization?.findIndex(
              (x) => x.id === selDeleteVoucherData?.id
            );
            allCustomization?.splice(currentDataIndex!, 1);
            updateCompanySettings!(
              selDeleteVoucherData?.templateType!,
              {
                ...companySettings,
                setting: {
                  ...companySettings?.setting!,
                  vouchersSettings: allCustomization!,
                },
              },
              findCurrentData,
              // selDeleteVoucherData?.templateName,
              IUpdateCompanySettings.delete,
              selDeleteVoucherData?.id
            ).then((result: any) => {
              if (result?.status) {
                // setSaveButtonLoading(false);
                openNotification(
                  "success",
                  `'${selDeleteVoucherData?.templateName}' deleted successfully.`
                );
                setDeleteTempleteComformation(false);
                setTrigger((prev: boolean) => !prev);
              } else {
                // setSaveButtonLoading(false);
                setDeleteTempleteComformation(false);
                openNotification(
                  "error",
                  result.message ?? "There is some error."
                );
              }
            });
          }}
          text={`Are you sure you want to delete this voucher template "${selDeleteVoucherData?.templateName}" ?`}
        />
      )}
    </>
  );
};

export default SettingSecCustomization;
